import bottleSlider from './bottleSlider'
import stepsSlider from './stepsSlider'
import imagesSlider from './imagesSlider'
import awardsSlider from './awardsSlider'

export default {
  init() {
    bottleSlider.init()
    imagesSlider.init()
    stepsSlider.init()
    awardsSlider.init()
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
